/**
 * Create_Custom_Payment_Schedule and Update_Custom_Payment_Schedule used to take a bare array
 * of items. They now take `NewPaymentScheduleModel`: a schedule-level description, an optional
 * advance timesheet payroll run id, and the items under `paymentScheduleItems`.
 *
 * Every screen that builds one of these still assembles the array, and each item repeats the
 * schedule description, so the wrapping is done once here rather than in five call sites. An
 * object passes through untouched, which is how a caller sends `advanceTimeSheetPayrollRunId`.
 *
 * Kept apart from paymentSchedulesService on purpose: that module pulls in the axios instances
 * at import time, which the test runner cannot transform, so a test of this shape would drag in
 * the whole HTTP layer to check an object literal.
 */
export type PaymentScheduleItemPayload = {
  advanceTimeSheetPayrollRunItemId?: number
  description?: string
  person_id?: string
  contractor_id?: string
  amount?: string
  source_currency_code?: string
  state?: string
  [key: string]: unknown
}

export type PaymentSchedulePayload = {
  description: string
  advanceTimeSheetPayrollRunId?: number
  paymentScheduleItems: PaymentScheduleItemPayload[]
}

export const toPaymentSchedulePayload = (body: any) => {
  if (!Array.isArray(body)) return body

  return {
    description: body[0]?.description ?? "",
    paymentScheduleItems: body,
  }
}
